import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import config from "../../config/config";

const HomePage = () => {
  const [properties, setProperties] = useState([]);
    const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch data function
  const getList = useCallback(async () => {
    try {
      setLoading(true);
      const result = await config.getAllProperties();
      setProperties(result.data || []); // ✅ Update state (not local variable)
    } catch (err) {
      setProperties([]); // Silently fail
    } finally {
      setLoading(false);
    }
  }, []);
let banner = async () => {
  const result = await config.getBannerByName("home");
  setBannerData(result.data || {});
};
const heroStyle = bannerData
  ? {
      backgroundImage: `url(${config.IMAGE_URL}banners/${bannerData.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "50vh",
    }
  : {};
  

  // ✅ Run only once
  useEffect(() => {
    getList();
    banner();
  }, [getList]);

  return (
    <>
        <section>
        <div className="head">

        </div>
      </section>
      <section className="hero" style={heroStyle}>
        <div className="hero-content">
          <h1>Find Your Perfect Home</h1>
          <p>Explore premium properties, connect with trusted agents, and make your move today</p>
          <br />
          <Link to="/property">Browse Properties</Link>
        </div>
      </section>

      {/* Featured Properties Section */}
      <section className="featured">
        <h2>Featured Properties</h2>
        <p>Handpicked selections from our latest listings—find homes that match your lifestyle</p>

        {loading && <p>Loading properties...</p>}

        {!loading && (
          <div className="property-grid">
            {properties.map((p) => {
              const firstImage = p.image?.includes(",") ? p.image.split(",")[0] : p.image || 'placeholder.png';

              return (
                <Link to={`/property/${p._id}`} key={p._id} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div className="property-card">
                    <img
                      src={`${config.IMAGE_URL}property/${firstImage}`}
                      alt={p.name}
                      className="property-image"
                    />
                    <div className="info">
                      <h3>{p.name}</h3>
                      {p.phone && <p>📞 {p.phone}</p>}
                      {p.email && <p>✉️ {p.email}</p>}
                      <div className="price">📍 {p.address}</div>
                    </div>
                  </div>
                </Link>
              );
            })}
            {properties.length === 0 && !loading && <p>No properties available</p>}
          </div>
        )}
      </section>

      {/* Help Section */}
      <section className="help-section">
        <div className="help-section-content">
          <h2>Why Choose RoomsForYou?</h2>
          <div className="help-grid">
            <div className="help-card">
              <h3>Sell Faster</h3>
              <p>Reach thousands of qualified buyers and get your property sold with transparent pricing.</p>
            </div>
            <div className="help-card">
              <h3>Rent Smart</h3>
              <p>Connect with trustworthy tenants and manage your rental with confidence.</p>
            </div>
            <div className="help-card">
              <h3>Live Better</h3>
              <p>Discover verified properties that fit your lifestyle, location, and budget perfectly.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
